import "./../styles.scss";

import { LoadingOutlined } from "@ant-design/icons";
import { Dropdown, Menu, notification, Pagination, Spin } from "antd";
import { ROLE } from "constants/phase";
import { Field, Form, Formik } from "formik";
import { includes } from "lodash";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useOutletContext } from "react-router-dom";

import CloseModal from "../../../components/icons/CloseModal";
import DeleteIcon from "../../../components/icons/DeleteIcon";
import TheeDotsIcon from "../../../components/icons/TheeDotsIcon";
import VideoFilm from "../../../components/icons/VideoFilm";
import { addPackageValidation } from "../../../utils/validations";
import DeletePackage from "./DeletePackage";
import EditPackage from "./EditPackage";
const AddPackage = ({ ...props }) => {
  const { settingsRecordsPerPage, id } = props;
  const { currentRole } = useOutletContext();
  const [isOpen, setIsOpen] = useState(false);
  const [costumFields, setCostumFields] = useState({});
  const [packageNames, setPackageNames] = useState([]);
  const [packageDetails, setPackageDetails] = useState({});
  const [editmodalOpen, setEditModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [disable, setDisable] = useState(false);
  const [packageLoader, setPackageLoader] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(20);

  const antIcon = <LoadingOutlined style={{ fontSize: 24, align: "center" }} spin />;

  const openModal = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [initialValues, setInitialValues] = useState({
    name: "",
    assignedCollectionId: "",
    digitalKeywords: "",
    tags: "",
  });

  const getCustomFields = async () => {
    setPackageLoader(true);
    const { getCustomFields } = props;
    const { value } = await getCustomFields({
      entityId: id,
    });
    if (value.success) {
      setCostumFields(value.setting);
      setPackageNames(value?.setting?.package_name);
      setPackageLoader(false);
    }
  };

  useEffect(() => {
    if (id) {
      getCustomFields();
    }
  }, [id]);

  const handlePageChange = (current) => {
    setActivePage(current);
    setEnd(current * settingsRecordsPerPage);
    setStart(current * settingsRecordsPerPage - settingsRecordsPerPage);
  };

  const setPackageName = (e, setFieldValue) => {
    setFieldValue("name", e);
    setInitialValues({ ...initialValues, name: e });
  };

  const setPackageAssignedCollection = (e, setFieldValue) => {
    setFieldValue("assignedCollectionId", e);
    setInitialValues({ ...initialValues, assignedCollectionId: e });
  };

  const setDigitalKeywords = (e, setFieldValue) => {
    setFieldValue("digitalKeywords", e);
    setInitialValues({ ...initialValues, digitalKeywords: e });
  };

  const setTags = (e, setFieldValue) => {
    setFieldValue("tags", e);
    setInitialValues({ ...initialValues, tags: e });
  };

  const getPackages = async (payload) => {
    setLoader(true);
    const { getPackages } = props;
    const { value } = await getPackages(payload);
    if (value.status) {
      getCustomFields();
      setLoader(false);
      notification["success"]({ message: value.message });
      setInitialValues({ ...initialValues, digitalKeywords: "", tags: "", name: "", assignedCollectionId: "" });
    }
  };
  const handleSubmit = async () => {
    if (packageNames.filter((e) => e.name === initialValues?.name).length > 0) {
      notification["error"]({ message: "Package Name Already Exists" });
    } else {
      const payload = {
        package: {
          name: initialValues?.name,
          assignedCollectionId: initialValues?.assignedCollectionId
            ? initialValues?.assignedCollectionId.split(",")
            : [],
          digital_keywords: initialValues?.digitalKeywords,
          tags: initialValues?.tags ? initialValues?.tags.split(",") : [],
        },
        entityId: id,
        action: "create",
      };
      getPackages(payload);
      closeModal();
    }
  };

  const editOpen = (data) => {
    setEditModalOpen(true);
  };

  const delOpen = (data) => {
    setDeleteModalOpen(true);
  };

  return (
    <>
      <EditPackage
        editmodalOpen={editmodalOpen}
        setEditModalOpen={setEditModalOpen}
        getPackages={getPackages}
        packageDetails={packageDetails}
        costumFields={costumFields}
        packageNames={packageNames}
        id={id}
      />
      <DeletePackage
        deleteModalOpen={deleteModalOpen}
        setDeleteModalOpen={setDeleteModalOpen}
        packageDetails={packageDetails}
        getPackages={getPackages}
        costumFields={costumFields}
        id={id}
      />
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Filter Modal"
        portalClassName="react-modal"
        overlayClassName="modal"
        className="modal-dialog react-modal-dialog-xs modal-dialog-centered"
      >
        <div className="modal-content">
          <div className="react-modal-header">
            <h5 className="react-modal-title">Add Package</h5>
            <button type="button" onClick={closeModal} className="btn btn__default">
              <CloseModal />
            </button>
          </div>
          <Formik initialValues={initialValues} validationSchema={addPackageValidation} onSubmit={handleSubmit}>
            {({ errors, touched, setFieldValue, values }) => (
              <Form>
                <div className="react-modal-body">
                  <div className="form-container">
                    <div className="form-group">
                      <label className="form-label">
                        Package Name <span className="required">*</span>
                      </label>
                      <Field
                        className="form-control"
                        name="packagename"
                        onChange={(e) => setPackageName(e.target.value, setFieldValue)}
                        value={initialValues?.name}
                      />
                      {touched.name && errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Assigned Collection Ids <span className="required"></span>
                      </label>
                      <Field
                        className="form-control"
                        name="assignedCollectionId"
                        onChange={(e) => setPackageAssignedCollection(e.target.value, setFieldValue)}
                        value={initialValues?.assignedCollectionId}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Digital Keywords<span className="required"></span>
                      </label>
                      <Field
                        className="form-control"
                        name="digitalkeywords"
                        onChange={(e) => setDigitalKeywords(e.target.value, setFieldValue)}
                        value={initialValues?.digitalKeywords}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        Tags<span className="required"></span>
                      </label>
                      <Field
                        className="form-control"
                        name="tags"
                        onChange={(e) => setTags(e.target.value, setFieldValue)}
                        value={initialValues?.tags}
                      />
                    </div>
                    <button className="btn btn-primary" type="submit" disabled={disable}>
                      Add
                      {loader === true ? <Spin indicator={antIcon} /> : ""}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Modal>
      <div className="col-md-12">
        <div className="border-block groups-block">
          <div className="left-block">
            <h4 className="title-sm-t">Package</h4>
          </div>
          <div className="right-btn-block">
            <div class="button-container">
              <button class="btn btn-primary" onClick={openModal}>
                Add package
              </button>
            </div>
          </div>
        </div>
        <br />
        <div className="configuration-items-row row">
          <div className="col-md-12">
            <div className="table-resposive table-container user-management-table">
              <table className="table">
                <thead>
                  <tr>
                    <th>Sno.</th>
                    <th>Package Name</th>
                    <th>Assigned Collection Ids</th>
                    <th>Digital Keywords</th>
                    <th>Tags</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {packageNames?.slice(start, end)?.map((data, ind) => {
                    return (
                      <tr>
                        <td>{ind + 1}</td>
                        <td>{data.name}</td>
                        <td>{data?.assignedCollectionId ? data?.assignedCollectionId.join(",") : ""}</td>
                        <td>{data?.digital_keywords ? data?.digital_keywords : ""}</td>
                        <td>{data?.tags ? data?.tags.join(",") : ""}</td>

                        <td>
                          <div className="table-action-block text-center">
                            <Dropdown
                              onClick={() => {
                                setPackageDetails(data);
                              }}
                              className=""
                              overlay={
                                <Menu
                                  items={[
                                    {
                                      label: (
                                        <a
                                          onClick={() => {
                                            editOpen(data);
                                          }}
                                        >
                                          <VideoFilm />
                                          <span>Edit</span>
                                        </a>
                                      ),
                                      key: "1",
                                    },
                                    includes([ROLE.ADMIN, ROLE.SUPER_ADMIN], currentRole)
                                      ? {
                                          label: (
                                            <a
                                              onClick={() => {
                                                delOpen(data);
                                              }}
                                            >
                                              <DeleteIcon />
                                              <span>Delete</span>
                                            </a>
                                          ),
                                          key: "2",
                                        }
                                      : null,
                                  ]}
                                />
                              }
                              trigger={["click"]}
                              overlayClassName={"tableActionBlock"}
                              placement={"bottomRight"}
                            >
                              <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
                                <TheeDotsIcon />
                              </a>
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Pagination
          showSizeChanger={false}
          current={activePage}
          pageSize={settingsRecordsPerPage}
          onChange={handlePageChange}
          total={packageNames?.length}
          className="text-center mt-3"
        />
      </div>
    </>
  );
};
export default AddPackage;
